/** Kanonische Mitarbeitertypen (Firestore-Feld `users.employmentType`) */
export type EmploymentType =
  | 'echomotion_intern'
  | 'autoboost_intern'
  | 'gesellschafter'
  | 'azubi_studi_prakti'
  | 'echomotion_usa'
  | 'echomotion_extern';

export const EMPLOYMENT_TYPE_VALUES: readonly EmploymentType[] = [
  'echomotion_intern',
  'autoboost_intern',
  'gesellschafter',
  'azubi_studi_prakti',
  'echomotion_usa',
  'echomotion_extern',
] as const;

export const EMPLOYMENT_TYPE_OPTIONS: { value: EmploymentType; label: string }[] = [
  { value: 'echomotion_intern', label: 'Echomotion intern' },
  { value: 'autoboost_intern', label: 'AutoBoost intern' },
  { value: 'gesellschafter', label: 'Gesellschafter' },
  { value: 'azubi_studi_prakti', label: 'Azubi/Studi/Prakti' },
  { value: 'echomotion_usa', label: 'Echomotion USA' },
  { value: 'echomotion_extern', label: 'Echomotion extern' },
];

const LABEL_BY_VALUE: Record<EmploymentType, string> = Object.fromEntries(
  EMPLOYMENT_TYPE_OPTIONS.map(o => [o.value, o.label])
) as Record<EmploymentType, string>;

export function isEmploymentType(v: unknown): v is EmploymentType {
  return typeof v === 'string' && (EMPLOYMENT_TYPE_VALUES as readonly string[]).includes(v);
}

/** Legacy `internal` / `freelancer` und unbekannte Werte auf kanonische Typen abbilden */
export function normalizeEmploymentType(raw: unknown): EmploymentType {
  if (raw === 'internal' || raw === undefined || raw === null || raw === '') {
    return 'echomotion_intern';
  }
  if (raw === 'freelancer') {
    return 'autoboost_intern';
  }
  if (isEmploymentType(raw)) {
    return raw;
  }
  return 'echomotion_intern';
}

export function employmentTypeLabel(type: EmploymentType): string {
  return LABEL_BY_VALUE[type] ?? type;
}
